/**
 * Inserts a space every 4 characters for readability.
 * @param {string} value - The string to group
 * @returns {string} The space-grouped string
 */
function groupBy4(value) {
    return String(value).replace(/(.{4})/g, "$1 ").trim();
}

/**
 * Formats an IBAN into space-separated groups of 4 characters.
 * @param {string} iban - The IBAN to format
 * @returns {string} The grouped IBAN, or a placeholder when empty
 */
function formatIban(iban) {
    if (!iban) return "Non renseigné";
    return groupBy4(String(iban).replace(/\s+/g, ""));
}

/**
 * Masks an IBAN keeping the first 4 and last 4 characters, e.g.
 * "FR76 XXXX XXXX XXXX 1234". Returns a placeholder when empty.
 * @param {string} iban - The full IBAN to mask
 * @returns {string} The masked, space-grouped IBAN
 */
function maskIban(iban) {
    if (!iban) return "Non renseigné";
    const clean = String(iban).replace(/\s+/g, "");
    if (clean.length <= 8) return groupBy4(clean);
    const masked = clean.slice(0, 4) + "X".repeat(clean.length - 8) + clean.slice(-4);
    return groupBy4(masked);
}

export { maskIban, formatIban };
